import { makeStyles } from 'tss-react/mui';
import { fonts, palette, getSpacing } from '../../styles';
import { NotificationType } from './Notification.types';
const ICON_UNITS = 7;
export const styles = (theme) => ({
    root: {},
    boxShadow: {
        boxShadow: '0 0 5px 0 rgba(30, 32, 36, 0.15)',
    },
    border: {
        border: `2px solid ${theme.palette.grey[200]}`,
    },
    statusIcon: {
        maxWidth: getSpacing(theme, 1) * ICON_UNITS,
        color: theme.palette.common.white,
    },
    iconWrapper: {
        height: '100%',
        paddingTop: theme.spacing(1 / 2),
        width: getSpacing(theme, 1) * ICON_UNITS,
        minHeight: getSpacing(theme, 1) * ICON_UNITS,
        alignItems: 'center',
        justifyContent: 'center',
    },
    iconWrapperDescription: {
        padding: theme.spacing(1),
        width: 'unset',
        alignItems: 'unset',
    },
    iconWrapperDescriptionChildren: {
        paddingTop: theme.spacing(2),
        alignItems: 'unset',
    },
    [NotificationType.SUCCESS]: {
        backgroundColor: palette.success.main,
    },
    [NotificationType.WARNING]: {
        backgroundColor: palette.warning.main,
    },
    [NotificationType.ERROR]: {
        backgroundColor: palette.error.main,
    },
    [NotificationType.INFO]: {
        backgroundColor: palette.info.main,
    },
    [NotificationType.ERROR_LIGHT]: {
        color: palette.error.main,
        backgroundColor: theme.palette.background.default,
    },
    [NotificationType.WARNING_LIGHT]: {
        color: palette.warning.main,
        backgroundColor: theme.palette.background.default,
    },
    [NotificationType.INFO_LIGHT]: {
        color: palette.info.main,
        backgroundColor: theme.palette.background.default,
    },
    [NotificationType.SUCCESS_LIGHT]: {
        color: palette.success.main,
        backgroundColor: theme.palette.background.default,
    },
    notificationMessage: {
        padding: theme.spacing(2),
    },
    notificationMessageDescription: {
        padding: `${theme.spacing(3 / 2)} ${theme.spacing(2)} ${theme.spacing(3 / 2)} ${theme.spacing(1 / 2)}`,
    },
    notificationMessageChildren: {
        paddingLeft: theme.spacing(0),
    },
    closeButton: {
        padding: theme.spacing(),
        fontSize: 10,
    },
    infoBackground: {
        backgroundColor: palette.info.light,
    },
    defaultBackground: {
        backgroundColor: theme.palette.background.default,
    },
    childrenStyle: {
        display: 'flex',
        paddingLeft: theme.spacing(ICON_UNITS),
        backgroundColor: theme.palette.common.white,
    },
    contentText: {
        fontSize: '13px',
        fontWeight: fonts.weights.regular,
        lineHeight: '21px',
        letterSpacing: '0.1px',
    },
});
export const useStyles = makeStyles()(styles);
//# sourceMappingURL=Notification.styles.js.map